import {NgModule} from '@angular/core';
import {TRANSLOCO_SCOPE, TranslocoModule} from '@ngneat/transloco';
import {NgSelectModule} from '@ng-select/ng-select';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbDatepickerModule, NgbDropdownModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {SharedModule} from 'shared/lib/shared.module';
import {SETTINGS_TRANSLATION_SCOPE} from 'shared/magic';
import {SettingsBarComponent} from './settings-bar/settings-bar.component';
import {FormElementsModule} from '../../../form-elements/src/lib/form-elements.module';

@NgModule({
	declarations: [
		SettingsBarComponent
	],
	imports: [
		TranslocoModule,
		NgSelectModule,
		CommonModule,
		ReactiveFormsModule,
		NgbDatepickerModule,
		SharedModule,
		FormsModule,
		NgbTooltipModule,
		NgbDropdownModule,
		FormElementsModule
	],
	providers: [
		{provide: TRANSLOCO_SCOPE, useValue: SETTINGS_TRANSLATION_SCOPE, multi: true},
	]
})
export class SettingsModule {
}
